/* eslint-disable */
import  _ from 'lodash';
import React from 'react';
import { render } from 'react-dom';
import GoogleMap from 'google-map-react';

/**
 * This is a simple component that renders a map onto a DOM node
 * with a single marker in the center.
 *
 * The DOM node to be mounted on should have a class `js-map` with the
 * following data attributes:
 *
 * data-lat     | the latitude for the center/marker
 * data-lng     | the longitude for the center/marker
 * data-api-key | google maps api key
 */
export default function renderMap() {
    const maps = document.getElementsByClassName('js-map');

    if (!maps.length) return;

    _.forEach(maps, map => {

        if (map.querySelector('.is-rendered')) return;

        const lat = Number(map.dataset.lat);
        const lng = Number(map.dataset.lng);

        render(
            <div className="is-rendered" style={{ width: '100%', height: '100%' }}>
                <GoogleMap
                    bootstrapURLKeys={{
                        key: map.dataset.apiKey
                    }}
                    center={{ lat, lng }}
                    zoom={14}
                >
                    <Marker lat={lat} lng={lng} />
                </GoogleMap>
            </div>,
            map
        );
    });
}

/**
 * A little red circle with a translucent border
 */
export function Marker() {
    return (
        <div className="marker marker--small"></div>
    );
}
